import { drOption } from "@robisoft/cross-library";

export class SendFormReq {
    responseCaptcha: string;
    repositoryGUID: string;
    store: string;
    email: string;
    emailModel: string;
    emailModel2: string;
    lang: string;
    to: string;
    cc: string;
    bcc: string;
    fields: drOption[];

    constructor() {
        this.responseCaptcha = '';
        this.repositoryGUID = '';
        this.store = '';
        this.email = '';
        this.emailModel = '';
        this.emailModel2 = '';
        this.lang = '';
        this.to = '';
        this.cc = '';
        this.bcc = '';
        this.fields = [];
    }
}